import form from './index.js'

// 获取礼包  /welfare/userGift
export function getgift(data) {
    return form.getrequest('/welfare/getGifts', data)
}
// 领取礼包  /welfare/productGift
export function lingqugift(data) {
    return form.postrequest('/welfare/productGift', data)
}

// export function dellevel(data) {
//     return form.postrequest('/guild/game/delete', data)
// }
//获取已领取礼包 /welfare/userGift
export function getgifted(data) {
    return form.getrequest('/welfare/userGift', data)
}